import React from 'react'

import Navbar from './Navbar'
import News from './News'

export const Home = () => {
  

  return (
    <div className='home'>
          <Navbar />
          <News />
    </div>
  )
}
